import CheckboxAndRadioContainer from "../../../../../Components/Forms&Table/Forms/FormControls/CheckboxAndRadio/CheckboxAndRadioContainer";

const CheckBoxAndRadio = () => {
  return <CheckboxAndRadioContainer />;
};

export default CheckBoxAndRadio;
